export default __webpack_public_path__ + "static/media/No77Open.46b82ad9.jpg";